import React from 'react';

/**
 * Aggregate view for the CEO Requests list (feature 066-ceo-requests).
 *
 * Rendered above the list and visually separated from it, so an aggregate can never be misread
 * as one request's detail — the same rule the other portal summaries follow.
 *
 * Every figure is computed over the CURRENT FILTERS, not the whole collection, so the cards and
 * the list can never disagree about what "matching" means.
 *
 * "Members" is the figure worth having beside the total: ten requests from one member and ten
 * from ten members are very different situations, and the total alone cannot tell them apart.
 */
export default function CeoRequestsSummaryPanel({ summary }) {
  if (!summary) return null;

  const total = summary.total || 0;
  const members = summary.unique_members || 0;

  return (
    <section className="au-cards cr-summary" aria-label="CEO requests summary">
      <div className="au-card">
        <span className="au-card__label">Total requests</span>
        <span className="au-card__value">{total}</span>
        <span className="au-card__sub">for the current filters</span>
      </div>

      <div className="au-card">
        <span className="au-card__label">Members</span>
        <span className="au-card__value">{members}</span>
        <span className="au-card__sub">
          {members === 1 ? 'one member wrote in' : 'distinct members wrote in'}
        </span>
      </div>
    </section>
  );
}
